import {
  createContext,
  useState
} from 'react'

export const SPKContext = createContext()

export const SPKContextProvider = ({ children }) => {
  const [indexAnalisa, setIndexAnalisa] = useState('')
  const [type, setType] = useState('')
  const [dataAnalisaBarangJadi, setDataAnalisaBarangJadi] = useState([])

  return (
    <SPKContext.Provider value={{
      indexAnalisa,
      type,
      dataAnalisaBarangJadi,
      setIndexAnalisa,
      setType,
      setDataAnalisaBarangJadi,
    }}>
      {children}
    </SPKContext.Provider>
  )
}
